/** Глобальні модалки/тості адмінки замість window.alert/confirm */

export type AdminToastKind = "success" | "error" | "info" | "warning";

export type AdminDialogState =
    | {
          mode: "alert";
          title: string;
          message: string;
          okText?: string;
          resolve: () => void;
      }
    | {
          mode: "confirm";
          title: string;
          message: string;
          confirmText?: string;
          cancelText?: string;
          danger?: boolean;
          resolve: (ok: boolean) => void;
      }
    | null;

export type AdminToastItem = {
    id: number;
    kind: AdminToastKind;
    message: string;
};

type Snapshot = {
    dialog: AdminDialogState;
    toasts: AdminToastItem[];
};

type Listener = () => void;

let dialog: AdminDialogState = null;
let toasts: AdminToastItem[] = [];
let toastSeq = 1;
let snapshot: Snapshot = { dialog: null, toasts: [] };
const listeners = new Set<Listener>();

function emit() {
    snapshot = { dialog, toasts };
    listeners.forEach((l) => l());
}

export function subscribeAdminDialog(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function getAdminDialogSnapshot(): Snapshot {
    return snapshot;
}

export function adminAlert(
    message: string,
    title = "Сообщение",
    okText = "OK",
): Promise<void> {
    return new Promise((resolve) => {
        if (dialog) {
            if (dialog.mode === "confirm") dialog.resolve(false);
            else dialog.resolve();
        }
        dialog = { mode: "alert", title, message, okText, resolve };
        emit();
    });
}

export function adminConfirm(
    message: string,
    opts?: {
        title?: string;
        confirmText?: string;
        cancelText?: string;
        danger?: boolean;
    },
): Promise<boolean> {
    return new Promise((resolve) => {
        if (dialog) {
            if (dialog.mode === "confirm") dialog.resolve(false);
            else dialog.resolve();
        }
        dialog = {
            mode: "confirm",
            title: opts?.title ?? "Подтверждение",
            message,
            confirmText: opts?.confirmText,
            cancelText: opts?.cancelText,
            danger: opts?.danger,
            resolve,
        };
        emit();
    });
}

export function closeAdminDialog(result?: boolean) {
    const d = dialog;
    dialog = null;
    emit();
    if (!d) return;
    if (d.mode === "confirm") d.resolve(Boolean(result));
    else d.resolve();
}

export function adminToast(message: string, kind: AdminToastKind = "info") {
    const id = toastSeq++;
    toasts = [...toasts, { id, kind, message }];
    emit();
    window.setTimeout(() => dismissAdminToast(id), 4200);
}

export function dismissAdminToast(id: number) {
    toasts = toasts.filter((t) => t.id !== id);
    emit();
}
